import { Box, Stack, Text } from "@chakra-ui/react";
import { CampaignsTable } from "./CampaignsTable";
import { EventDetailCampaignsSection } from "@common/interfaces/KYDEvent";
import { SectionProps } from "../../sections/sectionsComponents";
import EventDetailTitle from "../../../EventDetailTitle";

const CampaignsSection = ({
  data,
}: SectionProps<EventDetailCampaignsSection["data"]>) => {
  return (
    <Stack gap={8} overflow="scroll">
      <Stack
        direction={{ base: "column", md: "row" }}
        justify={"space-between"}
        w="100%"
      >
        <EventDetailTitle>Campaigns</EventDetailTitle>
      </Stack>
      <Box
        py={4}
        overflowX={(data?.campaigns || []).length === 0 ? "inherit" : "scroll"}
      >
        {(data?.campaigns || []).length === 0 ? (
          <Text color="gray.500">
            No campaigns created. Campaigns will populate here when the first
            click from the campaign is recognized.
          </Text>
        ) : null}
        {(data?.campaigns || []).length > 0 ? (
          <CampaignsTable data={data} />
        ) : null}
      </Box>
    </Stack>
  );
};

export default CampaignsSection;
